module.exports = __webpack_public_path__ + "img/icon-add.01049325.svg";